import { h } from 'preact';

const RedeemModalHeader = ({ headerTitle, onClose }) => {
  return (
    <div className="liana-redeem-modal-header">
      <div className="liana-redeem-modal-header-title liana-text-base">{headerTitle}</div>
      <svg
        width="13"
        fill="none"
        height="14"
        onClick={onClose}
        viewBox="0 0 13 14"
        xmlns="http://www.w3.org/2000/svg"
        className="liana-redeem-modal-header-close-button"
      >
        <path
          opacity="0.5"
          d="M1.52301 13.1876L12.8375 1.8731L11.7768 0.812445L0.462346 12.1269L1.52301 13.1876ZM0.462835 1.8731L11.7773 13.1876L12.8379 12.1269L1.5235 0.812443L0.462835 1.8731Z"
          fill="black"
        />
      </svg>
    </div>
  );
};

export default RedeemModalHeader;
